import { motion } from "framer-motion";

// Fade-up reveal on scroll into view.
export const fadeUp = {
  hidden: { y: 40, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
  },
};

const lineVariant = {
  hidden: { y: "115%" },
  visible: {
    y: "0%",
    transition: { duration: 1, ease: [0.16, 1, 0.3, 1] },
  },
};

export function Reveal({ children, className = "", delay = 0, once = true }) {
  return (
    <motion.div
      className={className}
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, margin: "-80px" }}
      transition={{ delay }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal. Pass an array of strings (lines).
export function MaskedLines({ lines, className = "", stagger = 0.12, animate = false }) {
  const container = {
    hidden: {},
    visible: { transition: { staggerChildren: stagger } },
  };
  const props = animate
    ? { initial: "hidden", animate: "visible" }
    : { initial: "hidden", whileInView: "visible", viewport: { once: true, margin: "-60px" } };

  return (
    <motion.span variants={container} {...props} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span variants={lineVariant} className="block">
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
}
